export default function Deferred() {
    var resolve, reject;
    var promise = new Promise(function(res, rej) {
        resolve = res;
        reject = rej;
    });

    var doneCallbacks = [];
    var failCallbacks = [];
    var state = 'pending';
    var resolvedArgs, rejectedArgs;

    function runCallbacks(list, args) {
        list.forEach(function(fn) { fn.apply(null, args); });
    }

    promise.then(
        function(val) {
            state = 'resolved';
            resolvedArgs = val;
            runCallbacks(doneCallbacks, [val]);
        },
        function(val) {
            state = 'rejected';
            rejectedArgs = val;
            runCallbacks(failCallbacks, [val]);
        }
    );

    var deferred = {
        resolve: function(val) { resolve(val); return deferred; },
        reject: function(val) { reject(val); return deferred; },
        promise: function() {
            var p = promise;
            p.done = function(fn) {
                if (state === 'resolved') fn(resolvedArgs);
                else doneCallbacks.push(fn);
                return p;
            };
            p.fail = function(fn) {
                if (state === 'rejected') fn(rejectedArgs);
                else failCallbacks.push(fn);
                return p;
            };
            p.success = p.done;
            p.error = p.fail;
            return p;
        }
    };

    return deferred;
}
